export default __webpack_public_path__ + "static/media/@melissaverli1.cbf68b2b.jpg";